var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal__offer" }, [
    _c(
      "div",
      {
        staticClass: "img",
        on: {
          click: function($event) {
            return _vm.$emit("close")
          }
        }
      },
      [
        _c("img", {
          attrs: {
            src: _vm.mediaBaseUrl + "after-quiz/close.svg",
            alt: "close"
          }
        })
      ]
    ),
    _vm._v(" "),
    _c("img", {
      attrs: { src: _vm.mediaBaseUrl + "after-quiz/timeout.png", alt: "" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "bg" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal-offer__content" },
      [
        _c("p", [_vm._v("Time's up")]),
        _vm._v(" "),
        _c("h2", [
          _vm._v("Get your personalized plan and keep track of your health")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "benefits" },
          _vm._l(_vm.benefits, function(benefit) {
            return _c("div", { key: benefit, staticClass: "benefit" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaBaseUrl + "after-quiz/benefit-marker.svg",
                  alt: "marker"
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(benefit))])
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "custom-button",
          {
            attrs: { primary: true },
            on: {
              click: function($event) {
                return _vm.$emit("changeModal", "payment")
              }
            }
          },
          [_vm._v("\n      Start Free Trial\n    ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }